import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, CardBody, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"
import { withRouter } from "react-router"
import DataTableAvisRattrapage from "./DataTableAvisRattrapage"
import AddAvisRattrapage from "./AddAvisRattrapage"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"

const AvisRattrapage = props => {
  const [section, setSection] = useState(1)

  const back = () => {
    setSection(1)
  }

  const renderBlock = section => {
    if (section === 1) {
      return <DataTableAvisRattrapage />
    } else if (section === 2) {
      return <AddAvisRattrapage setSection={setSection} back={back} />
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title> {props.t("Rattrapage")}</title>
        </MetaTags>
        <Container fluid>
          <div>
            <Nav tabs>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 1,
                  })}
                  onClick={() => {
                    setSection(1)
                  }}
                >
                  {props.t("Rattrapage")}
                </NavLink>
              </NavItem>
              {/*<NavItem>*/}
              {/*  <NavLink*/}
              {/*    style={{ cursor: "pointer" }}*/}
              {/*    className={classnames({*/}
              {/*      active: section === 2,*/}
              {/*    })}*/}
              {/*    onClick={() => {*/}
              {/*      setSection(2)*/}
              {/*    }}*/}
              {/*  >*/}
              {/*    {props.t("Ajouter rattrapage")}*/}
              {/*  </NavLink>*/}
              {/*</NavItem>*/}
            </Nav>
            <Card>
              <CardBody>{renderBlock(section)}</CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(AvisRattrapage))
AvisRattrapage.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,
}
